const fixMobileSafariWhiteScreenBug = () => {
    if (!document || !document.getElementsByTagName) return;

    const body = document.getElementsByTagName('body');
    if (body && body[0]) {
        body[0].style.display = 'none';
        /* eslint-disable no-unused-expressions */
        body[0].offsetHeight; // no need to store this anywhere, the reference is enough
        /* eslint-enable no-unused-expressions */
        body[0].style.display = '';
    }
};

export default fixMobileSafariWhiteScreenBug;



// WEBPACK FOOTER //
// ./src/js/utils/fixMobileSafariWhiteScreenBug.js